import { useId } from 'react';

/**
 * SquareCheckAnimatedIcon — Ícone de check em quadrado animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `check-animated`
 * para ativar a animação no hover (quadrado bounce, check pop com draw-in).
 *
 * Exemplo:
 *   <button className="btn-add check-animated" onClick={onConfirm}>
 *     <SquareCheckAnimatedIcon size={16} />
 *     <span className="btn-text">Editar</span>
 *   </button>
 */
export default function SquareCheckAnimatedIcon({ size = 16 }) {
  const id = useId();
  const gid = `checkG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="3" y1="12" x2="22" y2="4">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#154680" />
        </linearGradient>
      </defs>
      <g className="check-box" stroke={`url(#${gid})`}>
        <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"/>
      </g>
      <g className="check-tick" stroke={`url(#${gid})`}>
        <path d="m9 11 3 3L22 4"/>
      </g>
    </svg>
  );
}
